<style lang="scss" scoped>
label {
  strong {
    display: block;
    margin-bottom: 10px !important;
  }
  display: block;
  margin-bottom: 20px;
}

h2 {
  color: #4a4a4a;
}

.error {
  box-shadow: 0 0 0 0.1rem rgba(248, 83, 89, 0.2);
  border-bottom: 1px solid rgb(248, 83, 89);
  border-color: rgb(248, 83, 89);
}
</style>

<template>
  <main class="component-patients" >
    <form @submit.prevent="submit()">
      <h2>Avaliação clínica {{editing}} </h2>
      <hr />
      <label>
        <strong>Queixa principal*</strong>
        <textarea
          v-model="formData.mainComplaint"
          :ref="'mainComplaint'"
          :disabled="sent || !appointmentStarted"
          rows="7"
          class="col-12"
          placeholder="Escreva aqui a queixa relatada pelo paciente"
        />
      </label>
      <label>
        <strong>Hipótese diagnóstica*</strong>
        <dr-autocomplete
          :disabled="!appointmentStarted"
          :ref="'diagnosticHypothesis'"
          endpoint="cid"
          placeholder="Busque pelo código CID ou pelo nome da doença"
          :format="'{$code} - {$name}'"
          :fields="['name', 'code']"
          return-format="{$name}"
          :store-type="'cid'"
          :value.sync="formData.diagnosticHypothesis"
          :class="{ 'error': diagnosticHypothesisDirty }"
          @change="formData.diagnosticHypothesis = $event"
          >
        </dr-autocomplete>
      </label>
      <label>
        <strong>Diagnóstico final</strong>
        <dr-autocomplete
          :disabled="!appointmentStarted"
          endpoint="cid"
          placeholder="Busque pelo código CID ou pelo nome da doença"
          :format="'{$code} - {$name}'"
          :fields="['name', 'code']"
          return-format="{$name}"
          :store-type="'cid'"
          :value.sync="formData.finalDiagnostic"
          @change="formData.finalDiagnostic = $event"
          ref="finalDiagnostic"
          >
        </dr-autocomplete>
      </label>
      <label>
        <strong>Análise diagnóstica final</strong>
        <textarea :disabled="sent || !appointmentStarted" v-model="formData.diagnosticAnalysis"
          rows="7"
          class="col-12"
          type="text"
          placeholder="Escreva aqui o resultado final da avaliação clínica"/>
      </label>
      <dr-submit :disabled="$v.$invalid" class="btn-sm"  text="Salvar" :sending="sending"></dr-submit>
    </form>
    <hr />
  </main>
</template>

<script>
import drSubmit from '@/components/form/submit.vue'
import drAutocomplete from '@/components/form/autocomplete.vue'
import {required} from 'vuelidate/lib/validators'
import EventBus from '@/globals/eventBus'
import { AUTO_SAVE_INTERVAL } from '@/globals/constants'

export default {
  props: ['appointment', 'selectedEvaluation', 'evaluations', 'appointmentStarted', 'isMedicalHistoryVisible'],

  components: {
    drSubmit,
    drAutocomplete
  },

  data () {
    return {
      loaded: false,
      sending: false,
      sent: false,
      editing: false,
      cid: [],
      formData: {
        diagnosticHypothesis: null,
        diagnosticAnalysis: null,
        mainComplaint: null,
        finalDiagnostic: null
      },
      diagnosticHypothesisDirty: false,
      firstState: null,
      autoSave: null
    }
  },

  validations: {
    formData: {
      mainComplaint: {
        required
      },
      diagnosticHypothesis: {
        required
      }
    }
  },

  watch: {
    'selectedEvaluation' (next, prev) {
      if (!next) {
        return
      }
      this.editing = next.id

      for (let field in next) {
        if (this.formData.hasOwnProperty(this.fn_TO_CAMELCASE(field))) {
          this.formData[this.fn_TO_CAMELCASE(field)] = next[field]
        }
      }
    },

    'formData.mainComplaint' (next) {
      if ((next || '').length === 0) {
        this.$refs['mainComplaint'].classList.add('error')
        this.formData.mainComplaint = null

        return
      }

      this.$refs['mainComplaint'].classList.remove('error')
    },

    'formData.diagnosticHypothesis': {
      deep: false,
      immediate: false,
      handler (next) {
        if ((next || '').length === 0) {
          this.formData.diagnosticHypothesis = null
          this.diagnosticHypothesisDirty = true
        }
      }
    }
  },

  created () {
    EventBus.$on('submit-clinicalEvaluation', (args) => {
      if (!this.$v.$invalid) {
        this.submit(args)
        return
      }

      if (this.hasUnsavedData()) {
        this.$store.dispatch('setModalAlert', {
          title: 'Atenção',
          body: 'Este formulário contém dados inválidos e não foi possível salvá-lo.',
          size: 'md',
          active: true
        })
      }
    })

    this.createAutoSave()

    // EventBus.$on('pause-autosave', this.destroyAutoSave)
    // EventBus.$on('resume-autosave', this.createAutoSave)

    this.editing = null
    this.sent = false
    // this.$http
    //   .get(`/doctor/agenda?filterAnd[a.id]=${this.appointment.id}`, this.$store.getters.getAuthHeader)
    //   .then((res) => {
    //     console.log(res)
    //   })
    // console.log(this.appointment)

    for (let field in this.appointment) {
      if (this.formData.hasOwnProperty(this.fn_TO_CAMELCASE(field))) {
        this.formData[this.fn_TO_CAMELCASE(field)] = this.appointment[field]
        this.firstState = JSON.parse(JSON.stringify(this.formData))
      }
    }
  },

  destroyed () {
    this.destroyAutoSave()
  },

  methods: {
    submit ({ showConfirmation = true, nextSection = null, nextTab = null } = {}) {
      this.destroyAutoSave()

      EventBus.$emit('appointment-start-saving')

      this.sending = true
      this.fn_SHOW_PROGRESS()
      let id = this.editing || this.appointment.id
      const endpoint = `/agenda/${id}/clinical_evaluation`
      const data = { 'clinical_evaluation': this.formData }
      this.$http
        .put(endpoint, data, this.$store.getters.getAuthHeader)
        .then((res) => {
          if (showConfirmation) {
            this.$store.dispatch('setModalAlert', {
              title: 'Sucesso',
              body: 'Avaliação enviada com sucesso',
              size: 'md',
              active: true
            })
            setTimeout(() => {
              this.$store.dispatch('setModalAlert', {
                active: false
              })
            }, 2000)
          }
          this.sent = false
          this.sending = false

          if (nextSection) {
            EventBus.$emit('consultation-change-section', nextSection)
          }

          if (nextTab) {
            EventBus.$emit('consultation-change-tab', nextTab)
          }

          this.firstState = JSON.parse(JSON.stringify(this.formData))
          for (const [key, value] of Object.entries(this.firstState)) {
            this.$set(this.formData, key, value)
          }

          this.$emit('update', { ...JSON.parse(JSON.stringify(this.formData)) })
        }).catch(
          (err) => {
            console.log(err)
          })
        .finally(() => {
          this.fn_HIDE_PROGRESS()
          this.createAutoSave()

          EventBus.$emit('appointment-stop-saving')
        })
    },

    hasUnsavedData () {
      if (!this.formData.mainComplaint) {
        this.$nextTick(() => {
          this.$refs['mainComplaint'].classList.remove('error')
          // this.$refs['mainComplaint'].classList.add('error')
        })

        return false
      }

      if (!this.formData.diagnosticHypothesis) {
        this.diagnosticHypothesisDirty = true

        return false
      }

      return !(JSON.stringify(this.firstState) === JSON.stringify(this.formData))
    },

    autoSaveFn () {
      if (this.hasUnsavedData() && !this.$v.$invalid) {
        this.submit({ showConfirmation: false })
      }
    },

    destroyAutoSave () {
      clearInterval(this.autoSave)
      this.autoSave = null
    },

    createAutoSave () {
      this.autoSave = setInterval(this.autoSaveFn, AUTO_SAVE_INTERVAL * 1000)
    }
  }
}
</script>
